import { render, staticRenderFns } from "./CanvasOptBar.vue?vue&type=template&id=2d461423&scoped=true&"
import script from "./CanvasOptBar.vue?vue&type=script&lang=js&"
export * from "./CanvasOptBar.vue?vue&type=script&lang=js&"
import style0 from "./CanvasOptBar.vue?vue&type=style&index=0&id=2d461423&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d461423",
  null
  
)

export default component.exports